import { render, staticRenderFns } from "./duplicateCandidatePopover.vue?vue&type=template&id=7e05f5f1&scoped=true"
import script from "./duplicateCandidatePopover.vue?vue&type=script&lang=js"
export * from "./duplicateCandidatePopover.vue?vue&type=script&lang=js"
import style0 from "./duplicateCandidatePopover.vue?vue&type=style&index=0&id=7e05f5f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e05f5f1",
  null
  
)

export default component.exports